import { LitElement, PropertyValues, TemplateResult, html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js'
import { Task } from '@lit/task';
import { services } from "src/services";
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { raiseFetchResponseError } from 'src/modules/helpers/response-helpers';
import { nothingTemplate } from 'src/modules/helpers/lit-helpers';

@customElement('ctx-content-preview')
export class CtxContentPreview extends LitElement {
  @property({ type: String }) value: string = "";

  @property({ type: Boolean }) grow: boolean = false;
  @property({ type: Boolean }) scrollToCursor: boolean = true;
  @property({ type: Number }) cursorPosition?: number

  @property({ type: Object }) template = (htmlContent:string)=> unsafeHTML(htmlContent);

  @state() htmlContent: string = "";

  private _markdownPreviewTask: Task = new Task(this, {
    task: async ([value], { signal }) => {
      if(value===""){
        this.htmlContent = "";
        return value;
      }
      var response = await services.management.markdown.preview(value, signal).catch(raiseFetchResponseError);
      if(signal.aborted)
      {
        return this.value;
      }
      this.htmlContent = response.markup;
      return response.markup;
    },
    args: () => [this.value],
  });

  private _scrollToCursor() {
    if (this.scrollToCursor) {
      const bottomOffset = 100; // We want to check if the cursor is within the last 100 characters.
      const contentLength = this.value.length;
      let bottomPosition = contentLength <= bottomOffset ? contentLength : contentLength - bottomOffset;

      // If the cursor position is withing the last 100 characters of the content, add a scroll marker.
      if (this.cursorPosition != null && this.cursorPosition > bottomPosition) {
        this.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }
  }

  // This component is rendered using the light DOM to ensure the markdown being previewed renders as expected.
  // So styles are added to the render method to get it applied.
  render() {
    return html`${this._markdownPreviewTask.render({
      initial: () => nothingTemplate,
      pending: () => this.template(this.htmlContent),
      complete: () => this.template(this.htmlContent),
      error: (error) => html`<p>Oops, something went wrong: ${error}</p>`,
      })}`;
  }

  protected updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);
         requestAnimationFrame(() => {
           this._scrollToCursor();
        });
  }
}